import { Component, OnInit } from '@angular/core';
import { HttpRequestsService } from 'src/app/services/http-requests.service';
import { Model, StylesManager, SurveyNG } from "survey-angular";
import { Location } from '@angular/common';
import { environment } from 'src/environments/environment';
import * as showdown from 'showdown';

StylesManager.applyTheme("modern");

@Component({
  selector: 'app-template',
  templateUrl: './template.component.html',
  styleUrls: ['./template.component.scss'],
})
export class TemplateComponent implements OnInit {

  public city = history.state.city;
  public kpi = history.state.kpi;
  public action = history.state.action;
  public step = history.state.step;
  public user = history.state.user;
  public name: string;
  public productChoices: any = [
    "Fruits: Oranges",
    "Fruits: Apples",
    "Fruits: Bananas",
    "Fruits: Peaches",
    "Fruits: Apricots",
    "Fruits: Cherries",
    "Fruits: Watermelon",
    "Fruits: Melon",
    "Fruits: Pineapple",
    "Fruits: Pears",
    "Fruits: Berries",
    "Fruits: Lemons",
    "Fruits: Avocados",
    "Fruits: Tomatoes",
    "Fruits: Figues",
    "Fruits: Others",
    "Vegetables: Lettuce",
    "Vegetables: Cabbage",
    'Vegetables: Cucumber',
    "Vegetables: Coliflower",
    "Vegetables: Green beans",
    "Vegetables: Potatoes",
    "Leafy Green vegetables(spinach, chard, etc.)",
    "Vegetables: Onions",
    "Vegetables: Garlic",
    "Vegetables: Carrots",
    "Vegetables: Aubergine or Eggplant",
    "Vegetables: Pumpkin",
    "Vegetables: Artichoke",
    "Vegetables: Asparagus",
    "Vegetables: Peas",
    "Vegetables: Beetroot",
    "Vegetables: Broccoli",
    "Vegetables: Celery",
    "Vegetables: Peppers",
    "Vegetables: Fresh herbs",
    "Vegetables: Leek",
    "Vegetables: Mushrooms and other funghi",
    "Vegetables: Others",
    "Legumes",
    "Cereals, seeds and nuts",
    "Eggs",
    "Meat: Poultry",
    "Meat: Sheep",
    "Meat: Beef",
    "Meat: Pork",
    "Meat: Others",
    "Fish and Shellfish",
    "Dairy: Milk",
    "Dairy: Yogurt",
    "Dairy: Cheese",
    "Processed fruits and vegetables: Juice",
    "Processed fruits and vegetables: Fruits jams, marmelades and purees",
    "Processed fruits and vegetables: Pickles",
    "Processed fruits and vegetables: Vegetables soups and purees",
    "Cured meat",
    "Canned meat and fish",
    "Sauces",
    "Processed cereals: Buiscuits",
    "Processed cereals: Breakfast cereals, granolas and cereal bars",
    "Processed cereals: Bread",
    "Processed cereals: Pasta, noodles",
    "Snacks",
    "Beverages: Wine",
    "Beverages: Beer",
    "Oils and fats: Olive oil",
    "Oils and fats: Other oils",
    "Oils and fats: Butter and margarines",
    "Oils and fats: Other fats"
  ]
  public is20: boolean = false;

  public footNotes: any = '';

  constructor(private req: HttpRequestsService<any>, private _location: Location) { }

  ngOnInit(): void {
    this.req.getKpiTemplate(this.kpi).subscribe((res) => {
      this.name = res[0].kpi_name;
      if (this.name.substring(0, 2) === '20') {
        this.is20 = true;
      }
      const json = {
        requiredText: "",
        questions: [],
      };
      res.forEach((q) => {

        if (q.max_score === "2000") {
          this.footNotes = q.criteria;
        }

        else if (this.name.substring(0, 2) === '30') {
          const question = {
            isRequired: false,
            type: "matrixdynamic",
            addRowText: "Add More",
            rowCount: 1,
            minRowCount: 1,
            title: "Choose your local products from the drop-down menu",
            description: q.criteria,
            cellCount: 1,
            columns: [
              {
                name: "type",
                cellType: "dropdown",
                title: "Product",
                colCount: 1,
                choices: this.productChoices
              },
              {
                name: "local",
                title: "Price of local product (€)",
                cellType: "text",
                inputType: "number",
                min: 0,
                defaultValue: 0,
              },
              {
                name: "nonLocal",
                title: "Price of non-local product (€)",
                cellType: "text",
                inputType: "number",
                min: 0,
                defaultValue: 0
              },
            ],
          };
          json.questions.push(question);
        }

        else if (this.name.substring(0, 2) === "41") {
          const question = {
            isRequired: false,
            type: "matrixdynamic",
            addRowText: "Add More",
            rowCount: 1,
            minRowCount: 1,
            title: "Choose your local products from the drop-down menu",
            cellCount: 1,
            columns: [
              {
                name: "type",
                cellType: "dropdown",
                title: "Product",
                colCount: 1,
                choices: this.productChoices
              },
              {
                name: "volume",
                title: "Volume (kg)",
                cellType: "text",
                inputType: "number",
                min: 0,
                defaultValue: 0,
              },
            ],
          };
          json.questions.push(question);
        }

        else if (this.name.substring(0, 2) === "42") {
          const question = {
            isRequired: false,
            type: "matrixdynamic",
            addRowText: "Add More",
            rowCount: 1,
            minRowCount: 1,
            title: "Choose your local products from the drop-down menu",
            cellCount: 1,
            columns: [
              {
                name: "type",
                cellType: "dropdown",
                title: "Product",
                colCount: 1,
                choices: this.productChoices
              },
              {
                name: "totalVolume",
                title: "Total volume of annual local food sales (kg)",
                cellType: "text",
                inputType: "number",
                min: 0,
                defaultValue: 0,
              },
            ],
          };
          json.questions.push(question);
        }

        else if (q.max_score === "100" && q.kpi_name.substring(0, 2) !== "57" && q.kpi_name.substring(0, 2) !== "63") {
          const columns = q.answers.map((answer) => {
            return {
              name: answer,
              title: answer,
              cellType: "text",
              inputType: "number",
              min: 0,
              defaultValue: 0,
            };
          });

          const question = {
            isRequired: false,
            type: "matrixdropdown",
            description: q.criteria,
            title: q.question,
            columns: columns,
            rows: [
              {
                value: " ",
                text: ""
              }
            ],
          };

          json.questions.push(question);
        }

        else if (q.max_score === "1000") {
          const choices = q.answers.map((choice) => {
            return {
              value: choice,
              text: choice
            };
          });

          const question = {
            isRequired: false,
            type: 'checkbox',
            description: q.criteria,
            title: q.question,
            choices: choices,
          };

          json.questions.push(question);
        }


        else if (q.kpi_name.substring(0, 2) === "57") {
          const columns = q.answers.map((answer) => {
            return {
              name: answer,
              title: answer,
              cellType: "text",
              inputType: "number",
              min: 0,
              defaultValue: 0,
            };
          });

          const question = {
            isRequired: false,
            type: "matrixdynamic",
            addRowText: "Add More",
            rowCount: 0,
            minRowCount: 0,
            description: q.criteria,
            title: q.question,
            columns: columns,
            rows: [
              {
                value: " ",
                text: ""
              }
            ],
          };

          json.questions.push(question);
        }

        else if (q.kpi_name.substring(0, 2) === "63") {
          const columns = q.answers.map((answer, index) => {
            return {
              name: answer,
              title: answer,
              cellType: "text",
              inputType: "number",
              min: 0,
              defaultValue: 0,
            };
          });

          const question = {
            isRequired: false,
            type: "matrixdropdown",
            description: q.criteria,
            title: q.question,
            columns: columns,
            rows: [
              {
                value: " ",
                text: ""
              }
            ],
          };

          json.questions.push(question);
        }

        else {
          const totalChoices = q.answers.length;
          const choices = q.answers.map((choice, index) => {
            return {
              value: totalChoices - 1 - index,
              text: choice
            }
          });

          const question = {
            isRequired: false,
            type: 'radiogroup',
            description: q.criteria,
            title: q.question,
            choices: choices,
          };
          json.questions.push(question);

        }
      });

      const converter = new showdown.Converter();
      const survey = new Model(json);
      survey.onTextMarkdown.add(function (survey, options) {
        // Convert Markdown to HTML
        let str = converter.makeHtml(options.text);
        // Remove root paragraphs <p></p>
        str = str.substring(3);
        str = str.substring(0, str.length - 4);
        // Set HTML markup to render
        options.html = str;
      });

      SurveyNG.render("templateContainer", { model: survey });

      survey.completedHtml = "<span>KPI template completed! Thank you for your time and feedback!</span>";
      survey.onCompleting.add(function (sender) {

        var city = history.state.city;
        var kpi = history.state.kpi;
        var action = history.state.action;
        var step = history.state.step;
        var dataObj = JSON.stringify(sender.data);
        var step = history.state.step;
        var user = history.state.user;
        const xhr = new XMLHttpRequest();
        const url = environment.apiType + '://' + environment.apiUrl;
        //xhr.open("POST", `http://192.168.25.18:8006/kpis_eval?city=${city}&step=${step}&kpi=${kpi}&action=${action}&user=${user}`);
        xhr.open("POST", `${url}/api/v2/kpis_eval?city=${city}&step=${step}&kpi=${kpi}&action=${action}&user=${user}`);
        xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
        xhr.send(JSON.stringify(dataObj));
      })
      survey.onComplete.add(() =>
        setTimeout(() => {
          this._location.back()
        }, 2000));
    });

  }
}
